import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { ErrorToast, SuccessToast } from 'services/toasterService';

export default function useDeleteFolder(cb) {
  const queryClient = useQueryClient();

  return useMutation(
    async (data) => {
      const response = await makeApiRequest.delete(
        apiEndPoints.REPOSITORY_CURD_API,
        { data: data }
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        SuccessToast({ text: data?.message });
        cb();
        queryClient.invalidateQueries('repository-folders-sub-folder');
        queryClient.invalidateQueries('repository-folders');
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
